import { createSlice } from "@reduxjs/toolkit";

const initialDatasetStorageTypeState = {
  listLoading: false,
  actionsLoading: false,
  entities: null,
  lastError: null,
  UserProfileDetails: ""
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const RegisterAndLoginSlice = createSlice({
  name: "dl-registerAndLogin",
  initialState: initialDatasetStorageTypeState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    UserProfileDetails: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.UserProfileDetails = action.payload;
    },

    clearUserProfileDetails: (state, action) => {
      state.UserProfileDetails = "";
    }
  }
});
